import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { StoreInfoState } from "./storeDataStateType";

const initialState: StoreInfoState = {
  currency: "",
  countryCode: "",
  timezone: "",
  partnerStoreDomain: "",
  chatbotAttributionWindow: 0,
  productCount: 0,
  isNonShopifyStore: false,
};

const storeInfoSlice = createSlice({
  name: "StoreInfo",
  initialState: initialState,
  reducers: {
    addStoreInfoData: (state, action: PayloadAction<StoreInfoState>) => {
      const {
        currency,
        countryCode,
        timezone,
        partnerStoreDomain,
        chatbotAttributionWindow,
        productCount,
        isNonShopifyStore,
      } = action.payload;
      return {
        currency,
        countryCode,
        timezone,
        partnerStoreDomain,
        chatbotAttributionWindow,
        productCount,
        isNonShopifyStore,
      };
    },
    setCurrency: (state, action: PayloadAction<string>) => {
      state.currency = action.payload;
    },
    setTimezone: (state, action: PayloadAction<string>) => {
      state.timezone = action.payload;
    },
  },
});

export const storeInfoStateActions = storeInfoSlice.actions;
export default storeInfoSlice;
